import React from 'react'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/Users'
import connectIndex from '../../lib/connectIndex'
import withRouter from '../../lib/withRouter'

export class InternalUserIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    records: PropTypes.array,
    includeSearch: PropTypes.bool,
    flashMessages: PropTypes.array.isRequired,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    includeSearch: true,
    searchColumns: ['username', 'email']
  }

  static columns = [
    { key: 'username', label: 'Username' },
    { key: 'email', label: 'Email' }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/internal_users"
          name="Internal User"
          pagination={this.props.pagination}
          columns={InternalUserIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          includeSearch={this.props.includeSearch}
          searchColumns={this.props.searchColumns}
          additionalQueryParams={['user_type']}
          extraQueryParams={{ user_type: 'internal' }}
          history={this.props.history}
        />
      </div>
    )
  }
}

export default connectIndex(withRouter(InternalUserIndex), 'users', actions)
